import { downloadMultipleFiles, dropzonesUploadFiles, handleDisplayFormDetails } from "./application";
import { addressInput, displayErrorMessage, getEndPointApplication } from "./common";
import {
    CITIZEN_STATUS,
    COMMITMENT_CAR_TYPE,
    COMMITMENT_CREDIT_CARD_TYPE,
    COMMITMENT_HOME_TYPE,
    COMMITMENT_INVESTMENT_TYPE,
    COMMITMENT_OTHER_TYPE,
    COMMITMENT_PERSONAL_TYPE,
    INCOME_INCOME_TYPES,
    INCOME_TYPE_SELF_EMPLOYED,
    INCOME_OTHER_TYPES_GROUP,
    OWNERSHIP_LIVES_WITH_RELATIVES,
    OWNERSHIP_MORTGAGE, OWNERSHIP_OWNS_OUTRIGHT,
    OWNERSHIP_RENTS,
    PERMANENT_RESIDENT_STATUS,
    INCOME_PERMANENT_TYPES_GROUP,
    INCOME_FULL_TIME_TYPE,
    INCOME_PART_TIME_TYPE,
    INCOME_CASUAL,
    INCOME_INVESTMENT_PROPERTY,
    INCOME_DIVIDENDS,
    INCOME_PENSION,
    APPLICATION_CAR,
    ASSET_CONDITION_USED,
    PAYSLIP_TYPE,
    PROPOSAL_TYPE
} from "./constants";
$(document).ready(function () {
    handleConfirmClickNewResidential()
});

window.sfDocumentReady(['route-application-residential-edit', 'route-application-car-edit'], async () => {
    handleDisplayFormDetails();
    handleAddAnotherCommitment();
    handleStageIncome();
    runReview();
    dropzonesUploadFiles();
    handleChangeTextNoteUploadStep();
    handleRenderChildrenInfo();
    await reviewPage();
    // Review Page edit link, trigger click to sidebar step wizard
    $('.edit-stage-link').click(function () {
        const section = $(this).attr('href');
        $('.stepwizard-step')
            .children(`a[href="${section}"]`)
            .trigger('click');
    });

    $('.stepwizard-step.uploads')
        .children('a')
        .on('click', async () => {
            handleChangeTextNoteUploadStep();
        });
});

window.sfDocumentReady([
    'route-application-residential-edit',
    'route-application-residential-view',
    'route-application-car-edit',
    'route-application-car-view'
], async () => {
    handleStageBasic();
    downloadMultipleFiles();
});

window.sfDocumentReady([
    'route-application-car-edit',
], async () => {
    handleToggleCarInfoBasicStep();
});

window.sfDocumentReady([
    'route-application-residential-view',
    'route-application-car-view'
], async () => {
    function showChosenDropzoneContainer(element) {
        const containerId = (element).id;
        const containerElement = $(`.js-dz-container-${containerId}`);
        containerElement.removeClass('hidden');
        containerElement.show();
    }

    // condition dropzone hide and show
    $('.js-show-condition-container').click(function (event) {
        event.preventDefault();

        // Hide condition empty state
        $('.js-condition-empty-state').hide();

        // hide all condition containers
        $('.js-dz-element').hide();

        showChosenDropzoneContainer(this);
    });

    // Submit update status form when changing status field
    $('.js-submit-form-on-change').change(function () {
        $(this).parent('form').submit();
    });

    $('.js-confirm-delete').click(function () {
        return confirm('Are you sure you want to delete this application?');
    });

    $('.js-confirm-send-docs').click(function () {
        return confirm('Are you sure you want to send documents to all applicants?');
    });

    $('.js-confirm-send-esign-docs').click(function () {
        return confirm('Are you sure you want to decline signed agreement and resend to all applicants?');
    });
});

/**
 * It handles the comparison rate API call
 */
function handleStageBasic() {
    // Handle call comparison rate API
    const systemCostInput = $('#system_cost');
    const termInput = $('input[type=radio][name=term]');
    systemCostInput.on('focusout', () => {
        const term = $('input[type=radio][name=term]:checked').val();
        if (term) {
            getRepayments();
        }
    });
    termInput.on('change', function () {
        if (systemCostInput.val()) {
            getRepayments();
        }
    });
}

/**
 * It's a function that handles the income section of the form
 */
function handleStageIncome() {
    $('.income_type_select').on('change', function () {
        equifaxLookups()
        $('.js-display-errors').html('');
        $(this).closest('fieldset').find('input[type=checkbox]').prop('checked', false);
        const valueSelectIncomeType = this.value
        const $incomeType = $(this).closest('fieldset').find('.income_type_value');
        $incomeType.each(function () {
            const val = ($(this).val()).split(', ');
            const $containerDetail = $(this).closest('.container_detail');

            if (!val.includes(valueSelectIncomeType)) {
                $containerDetail.addClass("not_serialize").hide();
            } else {
                $containerDetail.removeClass("not_serialize").show();
            }

            updatePropertyAddressContainer(valueSelectIncomeType, $containerDetail);
        });
    });
    handleAddAnotherIncome()
    handleAddPreviousEmployment()
    equifaxLookups()
}

function updatePropertyAddressContainer(selectedIncomeType, $containerDetail) {
    const $propertyAddressContainer = $containerDetail.find('.container_property_address');

    if (parseInt(selectedIncomeType) === INCOME_INVESTMENT_PROPERTY) {
        $propertyAddressContainer.removeClass("not_serialize").show();
    } else {
        $propertyAddressContainer.addClass("not_serialize").hide();
    }
}

/**
 * It listens for changes to the `working_from_year` and `working_from_month` fields of the first
 * `.js-primary-income` element, and when either of those fields change, it calls the
 * `createNewPreviousEmployment` function
 */
function handleAddPreviousEmployment() {
    $('.js-primary-income').find('.working_from_year, .working_from_month').on('change', function () {
        createNewPreviousEmployment($(this))
    })
    $('.js-primary-income .income_type_select').on('change', function () {
        const $formContainer = $(this).closest('fieldset');
        if (!INCOME_PERMANENT_TYPES_GROUP.includes(this.value)) {
            $formContainer.find('.js-primary-income .permanent-detail .container_detail').hide()
            $formContainer.find('.js-primary-income .permanent-detail').find('.status').val(0)
        }
        else {
            createNewPreviousEmployment($formContainer.find('.js-primary-income').first().find('.working_from_year'))
        }
    })
}

/**
 * It creates a new employment form if the user has been working for less than 3 years
 * @param  - The input that triggered the event.
 */
function createNewPreviousEmployment($contextInput) {
    const $permanentForm = $contextInput.closest('.permanent-detail');
    const $formContainer = $contextInput.closest('form');
    const isHaveTimeWork = ($permanentForm.find('.working_from_year').val() || $permanentForm.find('.working_from_month').val()) ? true : false;
    const workingFromYear = parseInt($permanentForm.find('.working_from_year').val() || 0);
    const $lastPreviousIncome = $formContainer.find('.previous-income:first');
    const isNextPreviousIncome = $contextInput.closest('fieldset').next().hasClass('previous-income');
    if (workingFromYear < 3 && isHaveTimeWork) {
        $lastPreviousIncome.removeClass('not_serialize collapse');
        $lastPreviousIncome.find('.status').val(1);
        $lastPreviousIncome.show();
    }
    else if ((workingFromYear >= 3 || !isHaveTimeWork) && isNextPreviousIncome) {
        $lastPreviousIncome.find('.status').val(0);
        if ($lastPreviousIncome.find('.application_income_id').val()) {
            $lastPreviousIncome.hide();
            return;
        }
        $lastPreviousIncome.addClass('not_serialize collapse');
    }
}

/**
 * It adds a new income form when the user clicks the "Add another income" button
 */
function handleAddAnotherIncome() {
    $('.income-wrapper').each(function () { $(this).find('.other-income:last').addClass('last-other') })
    //clone other income if user have any income
    $('.last-other input[type=radio]').on('change', function () {
        const $wrapperContainer = $(this).closest('.income-wrapper');
        const $inputRadio = $(this);
        const nameRadio = $inputRadio.attr('name').split(']')[0];
        const currentIndex = parseInt(nameRadio.substring(nameRadio.indexOf('[') + 1));
        const $lastOtherContainer = $(this).closest('.other-income');
        const isClone = $wrapperContainer.find('.other-income:last').find('.container_detail').is(':visible');
        const newIndex = Date.now();
        if (this.value === '1' && isClone) {
            const $otherIncomeCloned = $lastOtherContainer.clone(true);
            $otherIncomeCloned.addClass('not_serialize');
            const newLabel = 'Do you have another source of income?';
            changeNameOfInput($otherIncomeCloned, currentIndex, newIndex, 'incomes');
            //reset attributes for other income clone
            $otherIncomeCloned.find('.control-label:first').html(`<b>${newLabel}</b>`);
            $otherIncomeCloned.find('.input_radio_yes').prop('checked', false);
            $otherIncomeCloned.find('.detail_of_attribute .input-data:not(.no-change-value)').val('');
            $otherIncomeCloned.find('.application_income_id').val('');
            $otherIncomeCloned.find('.input_radio_yes').attr('id', `other_income_type_${newIndex}`)
            $otherIncomeCloned.find('.input_radio_yes').siblings('label').attr('for', `other_income_type_${newIndex}`);
            $otherIncomeCloned.find('.input_radio_no').attr('id', `no_other_income_type_${newIndex}`)
            $otherIncomeCloned.find('.input_radio_no').siblings('label').attr('for', `no_other_income_type_${newIndex}`);
            $otherIncomeCloned.find('.container_detail').hide();
            $otherIncomeCloned.addClass('clone-other-income last-other').insertAfter($wrapperContainer.find('.other-income:last'));
            $otherIncomeCloned.find('.js-display-errors').html('');
            addressInput();
        }
        if (this.value === '0') {
            if (!$lastOtherContainer.hasClass('last-other') && !$wrapperContainer.find('.last-other').find('.application_income_id').val()) {
                $wrapperContainer.find('.last-other').remove();
            }
        }
        $wrapperContainer.find('.other-income').removeClass('last-other')
        $wrapperContainer.find('.other-income:last').addClass('last-other');
    });
}

function handleAddAnotherCommitment() {
    const $commitmentItems = $('.commitment-wrapper .commitment-item');

    $commitmentItems.last().find('input[type=radio]').on('change', function () {
        if (parseInt($(this).val()) === 1) {
            const nameAttribute = $(this).attr('name');
            const match = nameAttribute.match(/\[(\d+)\]/);

            if (match) {
                const indexName = match[1];
                let $otherCommitmentCloned = $('.commitment-item').last().clone(true)
                $otherCommitmentCloned = changeNameOfInput($otherCommitmentCloned, indexName, Date.now(), 'loans');
                $otherCommitmentCloned.find('.container_detail').hide();
                $otherCommitmentCloned.find('input.is-other-commitment').val(1);
                $otherCommitmentCloned.find('.js-display-errors').html('');
                $otherCommitmentCloned.find('input.loan_type').remove();
                $otherCommitmentCloned.insertAfter($('.commitment-item').last());
            }
        }
        if (parseInt($(this).val()) === 0) {
            $(this).closest('.commitment-item').nextAll().each(function () {
                if (!$(this).find('.application_commitment_id').val()) {
                    $(this).remove();
                }
            })
        }
    });
}

/**
 * It takes a container, the current index of the container, and the new index of the container, and
 * then it changes the name of the inputs in the container to the new index
 * @param  - the container of the input fields
 * @param currentIndex - the index of the current row
 * @param newIndex - the index of the new row
 * @returns The  is being returned.
 */
function changeNameOfInput($container, currentIndex, newIndex, name = '') {
    $container.find('.input-data').each(function () {
        const $input = $(this);
        let nameInput = $input.attr('name');
        let idInput = $input.attr('id');
        const nameField = nameInput.substring(nameInput.lastIndexOf('['));
        nameInput = `${name}[${newIndex}]${nameField}`;
        $input
            .attr('name', nameInput)
            .attr('id', `${idInput}_${newIndex}`)
            .prop('checked', false)
            .siblings('label')
            .attr('for', `${idInput}_${newIndex}`);
        if (!$(this).hasClass('no-change-value')) {
            $(this).val('')
        }
        // set class for error message
        const nameFieldNameError = nameField.substring(
            nameField.indexOf('[') + 1,
            nameField.lastIndexOf(']')
        );
        const $messageError = $input.siblings('.js-display-errors');
        $messageError.removeClass(`${name}_${currentIndex}_${nameFieldNameError}-err`);
        $messageError.addClass(`${name}_${newIndex}_${nameFieldNameError}-err`);
    })
    $container.find("option:selected").prop("selected", false)
    return $container;
}

/**
 * It gets the repayment amount, interest rate and comparison rate from the server and displays them on
 * the page
 * @returns the value of the variable 'data'
 */
function getRepayments() {
    const data = {
        id: $('.application_id').val(),
        application_type: $('#application_type').val(),
        system_cost: $('#system_cost').val().replaceAll(',', ''),
        system_cost_duration: $('#system_cost_duration').val(),
        finance_type: $('#finance_type').val(),
        system_cost_gst_status: $('#system_cost_gst_status').val(),
        term: $('input[type=radio][name=term]:checked').val(),
        rate_bracket: $('#rate_bracket').val()
    };
    window.httpPost('/repayments', data, {
        success(response) {
            $('.js-display-errors').html('');
            const { repayment, comparisonRate, interestRate } = response.data
            $('#repayment').val(repayment);
            $('#interest_rate').val(interestRate);
            $('#comparison_rate').val(comparisonRate);
        },
        error(response, status, error) {
            if (response.responseJSON && response.responseJSON.errors) {
                $('.system_cost-err').html(
                    response.responseJSON.errors['system_cost']
                );
            }
            if (ajaxErrorHandler(response.status)) {
                return;
            }
            notifyBox('Error', 'Error occurred, please try again', 'error');
        }
    });
}

/**
 * "Format a string of numbers into an Australian Business Number (ABN) format."
 *
 * The function takes a string of numbers and returns a string of numbers formatted as an ABN
 * @param number - The number to be formatted.
 * @returns the formatted ABN.
 */
function formatAbn(number) {
    number = number.replace(/\D/g, '');
    return `${number.substring(0, 2)} ${number.substring(2, 5)} ${number.substring(5, 8)} ${number.substring(8, 11)}`;
}

/**
 * It takes an ABN number, and if it's valid, it will populate the business name and applicant type
 * @param abn - The ABN number to lookup
 * @param  - The container of the ABN field.
 * @returns the value of the variable abn.
 */
function abnLookup(abn, $container) {
    if (abn === undefined) {
        return;
    }
    abn = abn.replace(/[^0-9]/g, '');
    $container.find('.business_name_text').html('');
    $container.find('.business_name').val('');
    $container.find('.applicant_type').val('');
    $('.progress-status').hide();
    if (abn.length === 0 || abn.length !== 11) {
        if (abn.length) {
            $container.find('.abn_number-err').css('display', 'block !important');
            $container.find('.abn_number-err').html('ABN number must be 11 digits long');
        }
        return;
    }
    $container.find('.abn_number-err').html('');
    // Looking up ABN
    const data = {
        abn,
        application_id: $('.application_id').val()
    };

    window.httpPost('/abnLookup', data, {
        success(response) {
            const dataResponse = response.data
            $container.find('.js-display-errors').html('');
            if (dataResponse.status !== 'success') {
                $('.button_save_incomes').prop('disabled', true);
                $container.find('.abn_number-err').css('display', 'block !important');
                $container.find('.abn_number-err').html(dataResponse.message);
                return;
            }
            if (!dataResponse.valid) {
                $container.find('.progress-status.st-success').hide();
                $container.find('.progress-status.st-fail').show();
                $container.find('.abn_number-err').css('display', 'block !important');
                $container.find('.abn_number-err').html(dataResponse.message);
                $('.button_save_incomes').prop('disabled', true);
                return;
            }
            const result = formatAbn(abn);
            $container.find('.abn_number').val(result);
            $container.find('.progress-status.st-fail').hide();
            $container.find('.progress-status.st-success').show();
            $container.find('.acn_number').hide();
            $container.find('.applicant_type_id').val(dataResponse.applicant_type_id);
            $container.find('.business_name_text').html(dataResponse.supplier.name);
            $container.find('.business_name').val(dataResponse.supplier.name);
            $('.button_save_incomes').prop('disabled', false);
            if (dataResponse.applicant_type_id === 4) {
                $container.find('.acn_number').show();
            }
        },
        error(response, status, error) {
            if (ajaxErrorHandler(response.status)) {
                return;
            }
            notifyBox('Error', 'Error occurred, please try again', 'error');
        }
    });
}

/**
 * It takes an ACN number, checks if it's valid, and if it is, it displays the company name
 * @param acn - The ACN number to lookup
 * @param lengthCheck - true/false
 * @param  - The container of the ACN field.
 */
function acnLookup(acn, lengthCheck, $container) {
    if (acn === undefined) {
        return;
    }
    acn = acn.replace(/[^0-9]/g, '');
    const errorField = $container.find('.acn_number-err');
    errorField.html('');
    $container.find('.business_acn_name_text').html('');
    $container.find('.business_acn_name').val('');
    $container.find('.progress-status-acn').hide();
    $('.button_save_incomes').prop('disabled', true);

    if (acn.length === 0 || acn.length !== 9) {
        if (acn.length) {
            $('.partnersDiv').hide();
        }
        if (acn.length && lengthCheck) {
            errorField.css('display', 'block !important');
            errorField.html('ACN number must be 9 characters long');
        }
        return;
    }

    // Looking up ACN
    $container.find('.progress-status-acn.st-success').hide();
    $container.find('.progress-status-acn.st-fail').hide();
    const data = {
        acn,
        application_id: $('.application_id').val()
    };

    window.httpPost('/acnLookup', data, {
        success(response) {
            const dataResponse = response.data
            $container.find('.js-display-errors').html('');
            if (dataResponse.status === 'success') {
                if (dataResponse.valid) {
                    $container.find('.business_acn_name').val(dataResponse.supplier.name);
                    $container.find('.business_acn_name_text').html(dataResponse.supplier.name);
                    $container.find('.progress-status-acn.st-success').show();
                    $('.button_save_incomes').prop('disabled', false);
                } else {
                    $container.find('.acn_number-err').html('ACN verification failed');
                    $container.find('.progress-status-acn.st-fail').show();
                }
                $('.js-after-abn').show();
            } else {
                $container.find('.acn_number-err').html(dataResponse.message);
                $container.find('.progress-status-acn.st-fail').show();
            }
        },
        error(response, status, error) {
            if (ajaxErrorHandler(response.status)) {
                return;
            }
            $container.find('.acn_number-err').html(
                'An unknown error occurred while trying to look up the ACN, please try again'
            );
            $container.find('.progress-status-acn.st-fail').show();
        }
    });
}

/**
 * If the income type is business, then trigger the ABN and ACN lookups on data input
 */
function equifaxLookups() {
    // If switching to the business tab, do equifax lookups
    const $incomeTypes = $('.income_type_select');
    $incomeTypes.each(function () {
        const $incomeType = $(this);
        const $containerIncome = $incomeType.closest('fieldset');
        const incomeType = $incomeType.find(":selected").val();
        if (Number(incomeType) === INCOME_TYPE_SELF_EMPLOYED) {
            const abnNumberField = $containerIncome.find('.abn_number');
            // Trigger ABN number lookups on data input
            // checks for length of abn value as well
            abnNumberField.on('change', () => {
                const acnHasValue = abnNumberField.length;
                const disableElement = !acnHasValue;
                $('.button_save_incomes').prop('disabled', disableElement);
                abnLookup(abnNumberField.val(), $containerIncome);
            });

            // Trigger ACN number lookups
            const acnNumberField = $containerIncome.find('.acn_number_input');
            acnNumberField.on('change', () => {
                acnLookup(acnNumberField.val(), false, $containerIncome);
            });
        }
    })
}

/**
 * It takes an individual and returns a string describing their property ownership
 * @param individual - The individual object that we're currently processing.
 * @returns A string
 */
function getPropertyOwnershipAsString(individual) {
    switch (individual.house_ownership) {
        case OWNERSHIP_OWNS_OUTRIGHT:
            return 'Owns outright';
        case OWNERSHIP_MORTGAGE:
            return 'Owns on a mortgage';
        case OWNERSHIP_RENTS:
            return 'Rents';
        case OWNERSHIP_LIVES_WITH_RELATIVES:
            return 'Lives with relatives';
    }

    return null;
}

/**
 * It takes a number and returns a string
 * @param frequency - The frequency of the payment. 1 = Weekly, 2 = Fortnightly, 3 = Monthly, 4 = Yearly
 * @returns the string representation of the frequency.
 */
function getFrequencyAsString(frequency) {
    switch (frequency) {
        case 1:
            return 'Weekly';
        case 2:
            return 'Fortnightly';
        case 3:
            return 'Monthly';
        case 4:
            return 'Yearly';
    }

    return null;
}

/**
 * It takes an individual and returns a string representation of their marital status
 * @param individual - The individual object that you want to get the marital status of.
 * @returns The marital status of the individual as a string.
 */
function getMaritalStatusAsString(individual) {
    switch (individual.marital_status) {
        case 1:
            return 'Single';
        case 2:
            return 'Married';
        case 3:
            return 'Defacto';
        case 4:
            return 'Divorced';
        case 5:
            return 'Widowed';
        default:
    }
    return null;
}

/**
 * It returns a string representation of the gender of an individual
 * @param individual - The individual object that you want to get the gender of.
 * @returns The gender of the individual.
 */
function getGenderAsString(individual) {
    switch (individual.gender) {
        case 1:
            return 'Male';
        case 2:
            return 'Female';
        case 3:
            return 'Prefer not to say';
        default:
    }
    return null;
}

/**
 * When the user clicks on the review step, start the review process
 * @param params - {
 */
function runReview(params) {
    $('.stepwizard-step.review')
        .children('a')
        .on('click', async () => {
            await startReview();
        });
}

/**
 * If the URL hash is #review, then validate all pages and then start the review process.
 */
async function reviewPage() {
    if (window.location.hash === '#review') {
        // validate pages when visiting the Review Page
        await startReview();
    }
}


/**
 * It checks if the application is complete, and if it is, it hides the consent form
 * @returns The application id is being returned.
 */
async function startReview() {
    const endPoint = getEndPointApplication()
    const applicationId = $('.application_id').val()
    if (!applicationId) return false
    await window.httpGet(`/${endPoint}/review/${applicationId}`, null, {
        success(response) {
            if (!response.data) {
                return;
            }
            const data = response.data;
            checkValidationReview(data)
            if (data.application.privacy_consent_type) {
                $('#consent-form-container').hide();
            }
        },
        error(response, status, error) {
            $('.submitApplication').prop('disabled', true);
            if (ajaxErrorHandler(response.status)) {
                return;
            }
            notifyBox(
                'Error',
                'Please check that all steps of the application are complete before reviewing the application.',
                'error'
            );
        }
    });
}

/**
 * It checks the validation of the application and renders the review page accordingly
 * @param data - the data object returned from the server
 */
function checkValidationReview(data) {
    const imgComplete = '/images/icons/check-circle-1.svg';
    const imgIncomplete = '/images/icons/alert-circle.svg';
    let completeAll = true;
    $.each(data.validation, (key, value) => {
        // Complete/incomplete with icon indicators
        if (value.status === 'success') {
            $(`#${key}`).find('.status').html('Complete');
            $(`#${key}`).find('.review-image .image').html(
                `<img src="${imgComplete}" class="image" height="20">`
            );
            switch (key) {
                case 'resStage_basic':
                    renderDescriptionBasicStage(key, data.application);
                    break;
                case 'resStage_individual1':
                    renderDescriptionIndividualStage(key, data.application.applicants[0]);
                    break;
                case 'resStage_individual2':
                    renderDescriptionIndividualStage(key, data.application.applicants[1]);
                    break;
                case 'resStage_commitments':
                    renderDescriptionCommitmentStage(key, data);
                    break;
                case 'resStage_income1':
                    const primaryIncome1 = data.application.applicants[0].incomes.find(income => income.is_primary_source)
                    renderDescriptionIncomeStage(key, primaryIncome1);
                    break;
                case 'resStage_income2':
                    const primaryIncome2 = data.application.applicants[1].incomes.find(income => income.is_primary_source)
                    renderDescriptionIncomeStage(key, primaryIncome2);
                    break;
                case 'resStage_expenses':
                    renderDescriptionExpensesStage(key, data.expenses);
                    break;
                case 'resStage_assets':
                    renderDescriptionAssetsStage(key, data.assets);
                    break;
                default:
                    break;
            }
            $(`#${key}`).find('.edit-stage-link').html('Edit');
            $(`#${key}`).find('.edit-stage-link').removeClass('button btn btn-submit');
        } else {
            $(`#${key}`).find('.status').html('Incomplete');
            $(`#${key}`).find('.review-image .image').html(
                `<img src="${imgIncomplete}" class="image" height="20">`
            );
            $(`#${key}`).find('.description-stage').html(value.msg);
            $(`#${key}`).find('.edit-stage-link').addClass('button btn btn-submit');
            $(`#${key}`).find('.edit-stage-link').html('Complete this step');
            $('#resStage_review').find('.description-stage').html(`
                <div class="mb-4">To proceed will need to sign a privacy consent.</div>
                <div>
                This will allow Solaris Finance to handle their information for the purposes of assessing
                a loan application. Further information will be provided on the document.
                </div>
            `);
            if (key !== 'resStage_review') {
                completeAll = false;
            }
        }
    });
    if (!completeAll) {
        $('#resStage_review').find('.description-stage').html("Please complete all the above steps before providing privacy consent.");
        $('#consent-form-container').hide();
        $('.consent-container').hide();
        $('.submitApplication').prop('disabled', true);
    } else {
        $('#consent-form-container').show();
        $('.consent-container').show();
        $('.submitApplication').prop('disabled', false);
    }
    $('#resStage_review').find('.edit-stage-link').hide();
}

/**
 * It renders the description of the application in the basic stage
 * @param element - The ID of the element you want to render the description into.
 * @param application - The application object
 */
function renderDescriptionBasicStage(element, application) {
    $(`#${element}`).find('.description-stage').html(
        `<div class="row sf-mb-3">
            <div class="col-md-4">Borrowing Amount</div>
            <b>$ ${application.system_cost}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Loan Term</div>
            <b>${application.term} Years</b>
        </div> `
    );
}

/**
 * It renders the description of the individual stage.
 * @param element - The id of the element that will contain the description.
 * @param applicant - The applicant object
 */
function renderDescriptionIndividualStage(element, applicant) {
    const fullName = `${applicant.first_name.trim()} ${applicant.middle_name.trim()} ${applicant.last_name.trim()}`;
    const citizenshipStatus = applicant.residency == CITIZEN_STATUS ? 'Citizen' : applicant.residency == PERMANENT_RESIDENT_STATUS ? 'Permanent Resident' : 'Visa';
    let content =
        `<div class="row sf-mb-3">
            <div class="col-md-4">Name</div>
            <b>${fullName}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Driver's Licence</div>
            <b>${applicant.driving_licence}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Driver's Licence card</div>
            <b>${applicant.driving_licence_card}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Date of Birth</div>
            <b>${applicant.dob}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Phone Number</div>
            <b>${JSON.parse(applicant.mobile)[0].work_phone}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Email Address</div>
            <b>${applicant.email}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Gender</div>
            <b>${getGenderAsString(applicant)}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Citizenship Status</div>
            <b>${citizenshipStatus}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Marital Status</div>
            <b>${getMaritalStatusAsString(applicant)}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Residential Address</div>
            <b>${applicant.location}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Residential Ownership</div>
            <b>${getPropertyOwnershipAsString(applicant)}</b>
        </div>
        <div class="row sf-mb-3">
            <div class="col-md-4">Living Duration</div>
            <b>${applicant.living_from_years} years, ${applicant.living_from_months || 0} months</b>
        </div>`;
    if (applicant.previous_addresses && applicant.previous_addresses.length) {
        let previousAddresses = '<div class="sf-mb-3">Previous address</div>';
        $.each(applicant.previous_addresses, (key, address) => {
            previousAddresses += `
            <div class="row sf-mb-3 sf-ml-3">
                <div class="col-md-4">Address</div>
                <b>${address.previous_location}</b>
            </div>
            <div class="row sf-mb-3 sf-ml-3">
                <div class="col-md-4">Living Duration</div>
                <b>${address.years} years, ${address.months || 0} months</b>
            </div>`
        })
        content += previousAddresses;
    }
    $(`#${element}`).find('.description-stage').html(content);

}

/**
 * It takes in an element and data, and then renders the data into the element
 * @param element - The id of the element you want to render the data in.
 * @param data - The data object that is passed to the template.
 */
function renderDescriptionCommitmentStage(element, data) {
    let html = `<div class="row sf-mb-3">
                    <div class="col-md-4">Children</div>
                    <b>${data.application.number_children || 0}</b>
                </div>`
    const loans = data.application.loans.filter(loan => !(loan.status === 0 && loan.is_other === 1))
    loans.forEach(loan => {
        let title = ''
        let value = ''
        switch (loan.loan_type) {
            case COMMITMENT_HOME_TYPE:
                title = 'Home Loan'
                value = loan.property_value
                break;
            case COMMITMENT_INVESTMENT_TYPE:
                title = 'Investment Property Loan'
                value = loan.property_value
                break;

            case COMMITMENT_CAR_TYPE:
                title = 'Car Loan'
                value = loan.balance_outstanding
                break;

            case COMMITMENT_CREDIT_CARD_TYPE:
                title = 'Credit Card or BNPL'
                value = loan.property_value
                break;

            case COMMITMENT_OTHER_TYPE:
                title = 'Other Commitments'
                value = loan.balance_outstanding
                break;

            case COMMITMENT_PERSONAL_TYPE:
                title = 'Personal Loan / BNPL'
                value = loan.balance_outstanding
                break;

            default:
                break;
        }
        if (loan.is_other === 1) title = `Other Commitments (${title})`
        if (loan.status === 0) value = 0
        html += `<div class="row sf-mb-3">
                    <div class="col-md-4">${title}</div>
                    <b>$ ${value}</b>
                </div>`

    });
    $(`#${element}`).find('.description-stage').html(html);
}

/**
 * It renders the description of the income stage.
 * @param element - The id of the element that contains the income stage.
 * @param income - The income object that you want to render.
 */
function renderDescriptionIncomeStage(element, income) {
    const jobType = Number(income.job_type)
    let contents = `
        <div class="row sf-mb-3">
            <div class="col-md-4">Type</div>
            <b>${INCOME_INCOME_TYPES[jobType] || ''}</b>
        </div>`;
    if (INCOME_PERMANENT_TYPES_GROUP.includes(jobType)) {
        contents += `
            <div class="row sf-mb-3">
                <div class="col-md-4">Job Title</div>
                <b>${income.job_title}</b>
            </div>
            <div class="row sf-mb-3">
                <div class="col-md-4">Employer Name</div>
                <b>${income.employer_name}</b>
            </div>
            <div class="row sf-mb-3">
                <div class="col-md-4">Employer Address</div>
                <b>${income.employer_address}</b>
            </div>
            <div class="row sf-mb-3">
                <div class="col-md-4">Time in Business</div>
                <b>${income.working_from_year || 0} years, ${income.working_from_month || 0} months</b>
            </div>`;
    }
    else if (jobType === INCOME_TYPE_SELF_EMPLOYED) {
        contents += `
            <div class="row sf-mb-3">
                <div class="col-md-4">ABN</div>
                <b>${income.abn_number || ''}</b>
            </div>
            <div class="row sf-mb-3">
                <div class="col-md-4">Business Address</div>
                <b>${income.business_address || ''}</b>
            </div>
            <div class="row sf-mb-3">
                <div class="col-md-4">Time in Business</div>
                <b>${income.working_from_year} years, ${income.working_from_month || 0} months</b>
            </div>`;
    }
    else {
        contents += `
            <div class="row sf-mb-3">
                <div class="col-md-4">Time in Business</div>
                <b>${income.working_from_year} years, ${income.working_from_month || 0} months</b>
            </div>`;
    }
    $(`#${element}`).find('.description-stage').html(contents);
}

/**
 * It takes an element and an array of expenses, and then it renders the expenses into the element
 * @param element - The id of the element you want to render the description to.
 * @param expenses - This is the array of expenses that you want to render.
 */
function renderDescriptionExpensesStage(element, expenses) {
    let contents = ``;
    $.each(expenses, (key, value) => {
        contents += `
            <div class="row sf-mb-3">
                <div class="col-md-4">${value.name}</div>
                <b>$ ${value.amount || 0}</b>
            </div>`
    })
    $(`#${element}`).find('.description-stage').html(contents);
}

/**
 * It takes an element and an array of assets, and then it renders the assets into the element
 * @param element - The id of the element that will be rendered.
 * @param assets - The assets array
 */
function renderDescriptionAssetsStage(element, assets) {
    let contents = ``;
    $.each(assets, (key, value) => {
        contents += `
            <div class="row sf-mb-3">
                <div class="col-md-4">${value.name}</div>
                <b>$ ${value.amount || 0}</b>
            </div>`
    })
    $(`#${element}`).find('.description-stage').html(contents);
}

/**
 * It handles the rendering of the children information
 */
function handleRenderChildrenInfo() {
    handleHtmlChildren(parseInt($('#number_children').val()));
    $('#number_children').on('change', function () {
        $('#js-children-info').html('');
        const numberChildren = parseInt($(this).val());
        handleHtmlChildren(numberChildren);
    });
}

/**
 * It takes a number as an argument and returns a string of HTML
 * @param numberChildren - The number of children the user has.
 */
function handleHtmlChildren(numberChildren) {
    let htmlChildren = '';
    const childrenInfo = JSON.parse($('#children_info').val() || "[]");
    for (let index = 0; index < numberChildren; index++) {
        const value = childrenInfo[index] ? childrenInfo[index].age : '';
        htmlChildren += `
            <div class="form-group not_serialize sf-mt-3">
                <label for="age_children_${index}" class="control-label col-md-12 sf-mb-4">
                    <b>How old is your ${getNumberWithOrdinal(index + 1)} child?</b>
                </label>
                <div class="col-md-4 col-sm-6 ffl-wrapper">
                    <input type="text" inputmode="numeric" name="children[${index}][age]" id="age_children_${index}"
                        placeholder="Number" value="${value}" class="input-field form-control js-positive-numeric-only" required>
                    <div class="error-span js-display-errors children_${index}_age-err"></div>
                </div>
                <div class="flow-root"></div>
            </div>`;
    }
    $('#js-children-info').html(htmlChildren);
}

/**
 * Get number with ordinal
 * @param n - The number to be converted to ordinal
 * @returns the number with the ordinal suffix.
 */
function getNumberWithOrdinal(n) {
    const s = ["th", "st", "nd", "rd"],
        v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

/**
 * It's a function that handles the click event of the button with the class `js-btn-new-residential`
 * and prevents the default action of the click event
 */
function handleConfirmClickNewResidential() {
    $('.js-btn-new-residential').on('click', function (e) {
        e.preventDefault();
        let urlNewApplication = 'https://apply.solarisfinance.com.au/new-residential'
        if ($('input.residential_referral-box__url.referral-box__url').val()) {
            urlNewApplication = $('input.residential_referral-box__url.referral-box__url').val()
        }
        confirm(
            'Due to NCCP regulation a customer must submit their own residential application. To do so please send them the following link:\n' +
            urlNewApplication
        )
        return false;
    })
}

function handleChangeTextNoteUploadStep() {
    const notes = []
    $('.income-wrapper fieldset input.income-status').each(function () {
        if (Number($(this).val()) === 1) {
            const incomeType = $(this).closest('fieldset').find('select.income_type_select').find(":selected").val()
            if (!notes.includes(incomeType)) {

                switch (Number(incomeType)) {
                    case INCOME_FULL_TIME_TYPE:
                    case INCOME_PART_TIME_TYPE:
                        notes.push('TWO most recent payslips')
                        break;

                    case INCOME_CASUAL:
                        notes.push('TWO most recent payslips', 'Notice of Assessment')
                        break;

                    case INCOME_PENSION:
                        notes.push('Centrelink Statement', '3 months Bank Statements')
                        break;

                    case INCOME_TYPE_SELF_EMPLOYED:
                        notes.push('Notice of Assessment')
                        break;

                    case INCOME_INVESTMENT_PROPERTY:
                        notes.push('Rental Statements')
                        break;

                    case INCOME_DIVIDENDS:
                        notes.push('Dividend Statements', '3 months Bank Statements')
                        break;

                    default:
                        break;
                }
            }

        }
    })
    const noteText = [...new Set(notes)].join(' AND ')
    $('.js-note-dynamic').text(noteText)
}

function handleToggleCarInfoBasicStep() {
    $('input[type=radio][name=asset_condition_status]').on('change', function () {
        const isUsed = parseInt(this.value) === ASSET_CONDITION_USED;
        $('.js-car-basic-info').toggleClass('collapse', !isUsed);
    });
}
